import React from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import Tooltip from "@components/tooltip";

import LicenseGroup, { licenseOption } from "./LicenseGroup";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const FreeAccess = () => {
  const { profile, baseUrl } = useStore();

  return (
    <div className={cx("licenses-block", "free-access-block", "color-yellow")}>
      <LicenseGroup
        refreshDisabled={profile.refreshLicenses.disabled}
        refreshLoading={profile.refreshLicenses.loading}
        refreshError={profile.refreshLicenses.error}
        refreshAction={profile.refreshLicenses.refresh}
        option={licenseOption.FREE_ACCESS}
        href={`https://billing.${baseUrl}/addinvoice?option=1&utm_source=header&utm_campaign=new_header&utm_content=header_addinvoice`}
        onClick={() => sendNavigationMetric("FREE_ACCESS_BILLING")}
        after={
          <>
            <span>{strings.profile_freeAccessText}</span>
            <Tooltip
              maxWidth={250}
              content={
                <span className={cx("free-access-tooltip")}>
                  <span>{strings.profile_freeAccessTooltip}</span>
                  <ul>
                    <li>{strings.viewContactsForCarsAndCargoes}</li>
                    <li>{strings.viewPassports}</li>
                  </ul>
                </span>
              }
            >
              <a
                href={`https://help.${baseUrl}/licenzii-uslugi-i-sposoby-oplaty?utm_source=header&utm_campaign=new_header`}
                target="_blank"
                rel="noopener noreferrer"
                className={cx("glz-link", "glz-is-primary", "free-access-link")}
                onClick={() => sendNavigationMetric("FREE_ACCESS_MORE")}
              >
                {strings.profile_whatsMore}
              </a>
            </Tooltip>
            <div className={cx("free-access-button-wrapper")}>
              <a
                className={cx(
                  "prolong-button",
                  "glz-button",
                  "glz-is-small",
                  "glz-is-primary",
                  "free-access-button"
                )}
                href={`https://billing.${baseUrl}/addinvoice?option=1&utm_source=header&utm_campaign=new_header&utm_content=header_addinvoice`}
                onClick={() => sendNavigationMetric("FREE_ACCESS_SELECT")}
              >
                {strings.profile_selectLicense}
              </a>
              <span className={cx("free-access-button-description")}>
                {strings.profile_fromPerMonth}
              </span>
            </div>
          </>
        }
      >
        {strings.profile_freeAccess}
      </LicenseGroup>
    </div>
  );
};

export default observer(FreeAccess);
